import {requestAnimationFrame} from 'CommonUtils/raf.js';

(function($) {
    

    let env = window.getparam('env') || 'prod';

    let liveRates_wrapper = $('#live-rates-table');
    let isLiveRatesLoaded = false, isLiveRatesLoading = false;

    let lang = languageAttributes.spokenLanguageCode;
    let lang_code = languageAttributes.languageCode;
    let broker = languageAttributes.broker;
    let brand = languageAttributes.brand;


    lang = lang == 'zh-hans' ? 'zh' : lang;

    let folders = {'en':16, 'en_sa':16, 'es':41, 'ar':25, 'hi':67, 'cn':120, 'tw': 16, 'cz': 167, 'hu': 92, 'en_uk':92, 'th': 65, 'ko': 182, 'ru':74, 'en_eu':16, 'hu_eu':92, 'cz_eu':167, 'de':80, 'nl':72, 'el':118, 'fr':78, 'it':70, 'pl':106, 'es':98};

    let exclude_tab = lang == 'zh' ? [1,7,8,9] : [8,9];

    lang = lang == 'kk' ? 'ru' : lang ; 

    lang_code = lang_code == 'kz' ? 'ru' : lang_code ; 
    

    
    let tabs;
    switch (lang) {
        case 'ru': 
            tabs = ['Популярные','Горячие','Валюты','Товары','Индексы','Акции','ETFS','Крипто']; 
            break;
        case 'en': 
            tabs = broker != '6' ? ['Most Popular','Top Movers','Currencies','Commodities','Indices','Shares','ETFs','Crypto'] : [];
            break;
        case 'hi': 
            tabs = ['सबसे लोकप्रिय','शीर्ष मूवर्स','मुद्राओं(करन्सी)','कमोडिटी','इंडेक्स ','शेयर्स ','ईटीएफ','क्रिप्टो'];
            break;
            case 'ar': 
            tabs = ['الأكثر شهره','الساخنة','العملات','السلع','المؤشرات','اسهم مالية','صناديق الاستثمار ETFs ','النقود الافتراضية'];
            break;
        case 'es': 
            tabs = broker == '3' ? ['Más populares','Los candentes','Monedas','Materias primas','Índices','Acciones','ETF','Criptomonedas'] : 
            ['Más Popular','Los Candentes','Monedas','Materias Primas','Indices','Acciones','ETF', 'Criptomonedas']; 
            break;
        case 'ko': 
            tabs = ['인기 종목','Top종목','통화','원자재','지수','주식(CFD)','ETFs','암호화화폐']; 
            break;
        case 'th': 
            tabs = ['ที่นิยมมากที่สุด','ร้อนแรง','สกุลเงิน','สินค้าโภคภัณฑ์','ดัชนี','หุ้น','กองทุนรวม','Crypto']; 
            break;
        case 'tw': 
            tabs = ['最受歡迎','Top變動排名','貨幣','大宗商品','指數','股票','ETFs','虛擬貨幣']; 
            break;
        case 'fr': 
            tabs = ['Les plus populaires', 'Les plus actifs' ,'Devises' ,'Commodités' ,'Indices', 'Actions' ,'FNB','Crypto']; 
            break;
        case 'it': 
            tabs = ['Più Popolari', 'Top Movers', 'Valute', 'Materie Prime', 'Indici', 'Titoli', 'ETFs', 'Cripto']; 
            break;
        case 'el': 
            tabs = ['Δημοφιλέστερα', 'Τα πιο καυτά προϊόντα',  'Νομίσματα', 'Εμπορεύματα',  'Δείκτες',  'Μετοχές', 'ETFs', 'Crypto']; 
            break;
        case 'pl': 
            tabs = ['Najbardziej Popularne', 'Najbardziej Zmienne', 'Waluty', 'Surowce', 'Indeksy', 'Akcje', 'ETF-y', 'Krypto']; 
            break;
        case 'nl': 
            tabs = ['Meest populair', 'Grootste verschuivingen', 'Valuta'+"'"+'s', 'Grondstoffen', 'Indexen', 'Aandelen', 'ETFs', 'Cryptovaluta']; 
            break;
        case 'de': 
            tabs = ['Populärste', 'Top-Mover', 'Währungen', 'Rohstoffe', 'Indizes', 'Aktien', 'ETFs', 'Kryptos']; 
            break
        case 'hu': 
            tabs = broker == '6' ? ['Legnépszerűbb','Devizák','Nyersanyagok','Indexek','Részvény CFD','ETF-ek'] : 
                                   ['Legnépszerűbb','Top változók','Devizák','Tőzsdei áruk','Indexek','Részvények ','ETF','Kripto']; 
            break;
        case 'cs': 
            tabs = broker == '6' ? ['Nejoblíbenější','Měny','Komodity','Indexy','Akcie','ETF'] : 
                                ['Nejpopulárnější','Nejvlivnější','Měny','Komodity','Indexy','Akcie','ETFs','Krypto']; 
            break;
        default:
            tabs = [];
    }

    
    let deepLink = broker === "1" ?  'https://trader.iforex.com/' : "https://trader.iforex.eu/"; 

    async function loadRates() {

        const script = document.createElement('script');
        document.body.appendChild(script);
        script.async = true;
        script.defer = true;
        script.src = 'https://content.webapi-services.net/web_assets/scripts/live-rates/widget.var.min.js?env='+env;
        script.onload = () => {
            LiveRates.default({
                folder: folders[lang_code],
                broker: broker,
                frequency: 6000,
                container: 'live-rates-table',
                activeTab: 0,
                maxLines: false,
                //exclude : ['high','low'],
                cssLink: '',
                lang: lang,
                exclude_tab:exclude_tab,
                icons: true,
                tabs_text : tabs,
                deepLink : deepLink
            }).then(function () {
                import(/* webpackPreload: true */'./live-rates.css');
                
                
                const skeleton = document.getElementById('live-rates-skeleton');
                
                skeleton &&  requestAnimationFrame(()=> skeleton.classList.add('hide'));

                

                $('.lr-loader').hide();
           
            })
        }; 

    }

    function doScrolling() {
        if (!isLiveRatesLoaded && liveRates_wrapper.html().trim() === '' && window.isInViewport(liveRates_wrapper)) {
            if (!isLiveRatesLoading) {
                isLiveRatesLoading = true;
                loadRates()
                    .then(() => {
                        isLiveRatesLoading = false;
                        isLiveRatesLoaded = true;
                    })
                    .catch(err => {
                        isLiveRatesLoading = false;
                        isLiveRatesLoaded = false;
                        console.error(err);
                    })
            }
        }
    }

   

  window.scrollingTasks.push(doScrolling);
})($);


